import { CardMedia, Typography } from "@material-ui/core";
import { push } from "connected-react-router";
import { useDispatch, useSelector } from "react-redux";

import icon from "../../../assets/icons/error.svg";
import { Button } from "../../../components/Button";
import { Heading } from "../../../components/Heading";
import {
  selectFormType,
  setFooterVisibility,
} from "../../../components/formSettings.slice";
import { useHideFooter, usePreventRefresh } from "../../../hooks";
import { mapFormTypeToSummary } from "../../../router/utilities";
import { GenericScreen } from "../../GenericScreen";
import { resetSender } from "../sender.slice";

import styles from "./Error.module.scss";

export const SendingError = (): JSX.Element => {
  useHideFooter();
  const dispatch = useDispatch();
  const formType = useSelector(selectFormType);
  const url = mapFormTypeToSummary[formType];
  const handleRedirect = () => {
    dispatch(resetSender());
    dispatch(setFooterVisibility(true));
    dispatch(push(url));
  };
  usePreventRefresh();

  return (
    <GenericScreen>
      <CardMedia component="img" src={icon} className={styles.icon} />
      <Heading
        align="center"
        color="secondary"
        component="h1"
        variant="h2"
        spacingBottom={{ xs: 4, sm: 6 }}
      >
        Wystąpił błąd przy wysyłaniu formularza
      </Heading>
      <Typography paragraph align="center">
        Mamy nadzieję, że to tylko chwilowy problem serwera...
        <br />
        Spróbuj ponownie przesłać formularz.
      </Typography>
      <Button
        color="primary"
        onClick={handleRedirect}
        spacingTop={5}
        variant="contained"
      >
        Wróć do formularza
      </Button>
    </GenericScreen>
  );
};
